import eventbus from 'tiny-emitter/instance';
import { loadPredefinedUnit } from '../models/predefined';
import { PredefinedShape } from '../models/predefined/predefined';
import Application from '../application';
import SVG from 'svg.js';

export default class DrawingStagePin {
  mouseListenerOptions = {
    passive: false,
    capture: false,
  };

  coords = Object.create(null);
  app: Application;
  svg: SVG.Doc;
  canvas: SVG.Nested;
  view: SVG.G;
  shape: SVG.Shape;

  constructor(app: Application) {
    this.app = app;
    this.svg = this.app.svg;
    this.canvas = app.canvas;
    this.view = this.canvas.group();

    this.app.seatmap.stagepin?.destroy();
    this.shape = loadPredefinedUnit('pin', this.svg).hide();
    this.view.add(this.shape);
    this.setup();
    this.setupEventListeners();
    return this;
  }

  setup() {
    this.setCanvasCursor();
    eventbus.emit('drawing:started');
  }

  setupEventListeners() {
    this.app.svg.on('mousemove', this.handleMouseMove, this);
    this.app.svg.on('click', this.handleMouseClick, this);
  }

  setCanvasCursor() {
    this.canvas.attr({ cursor: 'none' });
  }

  handleMouseClick(e: MouseEvent) {
    if (e.button !== 0) return;
    const sid = this.app.currentSection && this.app.currentSection.uuid;
    const { x, y } = this.app.getTransformedCoords(e);
    const attributes = {
      unitType: 'pin',
      position: [x, y],
    };
    const unit = PredefinedShape.create({ sid, attributes });
    this.app.seatmap.stagepin = unit;
    eventbus.emit('seatmap:add:unit', unit, false);
  }

  handleMouseMove(e: MouseEvent) {
    if (e.button !== 0) return;
    this.shape.show();
    const { x, y } = this.app.getTransformedCoords(e);
    this.view.move(x, y);
  }

  resetCanvasCursor() {
    this.canvas.attr({ cursor: 'default' });
  }

  destroyViews() {
    this.view.remove();
  }

  destroyEventListeners() {
    this.app.svg.off('mousemove', this.handleMouseMove, this);
    this.app.svg.off('click', this.handleMouseClick, this);
  }

  destroy() {
    this.resetCanvasCursor();
    this.destroyEventListeners();
    this.destroyViews();
  }
}
